import React from 'react';
import clsx from 'clsx';
import { AlertTriangle } from 'lucide-react';
import styles from './WarningNotice.module.css';

export interface WarningNoticeProps extends React.HTMLAttributes<HTMLDivElement> {
  icon?: React.ReactNode;
  children: React.ReactNode;
}

const WarningNotice: React.FC<WarningNoticeProps> = ({
  icon,
  children,
  className,
  ...props
}) => {
  return (
    <div className={clsx(styles.warningNotice, className)} {...props}>
      {icon !== undefined ? icon : <AlertTriangle size={20} />}
      {children}
    </div>
  );
};

export default WarningNotice;
